<template>
  <div class="flex h-full">
    <div class="w-8 bg-black text-white p-2 flex flex-col justify-center items-center">
      <router-link :to="{ name: 'bingo.index' }" class="mb-16" >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="a" d="M16.25,23.25,5.53,12.53a.749.749,0,0,1,0-1.06L16.25.75"/></svg>
      </router-link>
      <div @click.prevent="shuffle_images">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="a" d="M10.1 9A5.617 5.617 0 006 6.748H.75M23.25 6.748H18c-3.75 0-6 5.25-6 5.25s-2.25 5.25-6 5.25H.75M13.9 15a5.61 5.61 0 004.1 2.248h5.25"/><path class="a" d="M20.25 3.748l3 3-3 3M20.25 14.248l3 3-3 3"/></svg>
      </div>
    </div>


    <transition-group name="shuffleInstant" tag="div" class="flex-grow deck flex flex-wrap h-full">
      <bingo-card
        v-for="item in collection"
        :key="item.filename"
        :collectionName="collectionName"
        :config="config"
        :item="item"
      />
    </transition-group>
  </div>
</template>

<script>
import shuffleSeed from 'shuffle-seed'
import BingoCard from '@/components/bingo-card'

export default {
  components: {
    BingoCard
  },

  data () {
    return {
      collection: [],
      collectionName: ''
    }
  },

  computed: {
    config () {
      return this.$store.state[this.collectionName].config
    }
  },

  created () {
    this.collectionName = this.$route.params.id
    this.shuffle_images()
  },

  methods: {
    shuffle_images () {
      const free_filename = 'free.jpg'
      const seed = Math.random()

      // collect all images except for the "free" one
      const images = this.$store.state[this.collectionName].images.filter(image => image.filename !== free_filename)
      const free = this.$store.state[this.collectionName].images.filter(image => image.filename == free_filename).pop()

      // shuffle the images with the seed
      const shuffledImages = shuffleSeed.shuffle(images, seed)

      // insert the "free" image in the center
      shuffledImages.splice(12, 0, free)

      this.collection = shuffledImages
    }
  }
}
</script>

<style>
  .deck {
    @apply border border-black;
  }

  .shuffleFast-move {
    transition: transform 0.5s;
  }
  
  .shuffleInstant-move {
    transition: transform 0s;
  }
</style>
